"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _Logo = _interopRequireDefault(require("./Logo"));
var _SidebarItem = _interopRequireDefault(require("./SidebarItem"));
var _variables2 = _interopRequireDefault(require("@/assets/styles/variables.scss"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SidebarItem: _SidebarItem.default,
    Logo: _Logo.default
  },
  data: function data() {
    return {
      isResizing: false,
      startX: 0,
      startWidth: 0,
      minWidth: 180,
      // 最小宽度
      maxWidth: 500 // 最大宽度
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['sidebarRouters', 'sidebar'])), (0, _vuex.mapState)({
    sidebarWidth: function sidebarWidth(state) {
      return state.app.sidebar.width || '200px';
    }
  })), {}, {
    activeMenu: function activeMenu() {
      var route = this.$route;
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables2.default;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  mounted: function mounted() {
    // 初始化 CSS 变量，确保 Layout 中的 header 宽度正确
    document.documentElement.style.setProperty('--sideBarWidth', this.sidebarWidth);
    // 全局监听 mouseup 和 mousemove，防止鼠标移出侧边栏后拖拽失效
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  methods: {
    handleMouseDown: function handleMouseDown(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      // 解析当前宽度字符串为数字
      var currentWidth = parseInt(this.sidebarWidth, 10) || 210;
      this.startWidth = currentWidth;

      // 禁止选中文本
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';

      // 可选：添加一个类名高亮手柄
      // this.$el.querySelector('.sidebar-resizer').classList.add('resizing')
    },
    handleMouseMove: function handleMouseMove(e) {
      if (!this.isResizing) return;
      var deltaX = e.clientX - this.startX;
      var newWidth = this.startWidth + deltaX;

      // 限制宽度范围
      if (newWidth < this.minWidth) newWidth = this.minWidth;
      if (newWidth > this.maxWidth) newWidth = this.maxWidth;
      var newWidthStr = "".concat(newWidth, "px");

      // 1. 更新 Vuex Store (推荐，这样 Header 等组件能联动)
      this.$store.dispatch('app/setSideBarWidth', newWidthStr);

      // 2. 同时更新 CSS 变量，确保样式即时生效 (双重保险)
      document.documentElement.style.setProperty('--sideBarWidth', newWidthStr);
    },
    handleMouseUp: function handleMouseUp() {
      if (this.isResizing) {
        this.isResizing = false;
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
      }
    }
  }
};